export default __webpack_public_path__ + "static/media/Step4-Lovrican.a428558b.png";